(function () {
  var KEY = 'rst_wishlist_v1';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
    catch (e) { return []; }
  }
  function write(items) {
    localStorage.setItem(KEY, JSON.stringify(items));
    window.dispatchEvent(new CustomEvent('rst:wishlist-changed', { bubbles: true }));
  }
  function has(id) {
    id = String(id);
    return read().some(function (i) { return String(i.id) === id; });
  }
  function toggle(item) {
    var list = read();
    var id = String(item.id);
    var next = list.filter(function (i) { return String(i.id) !== id; });
    if (next.length === list.length) next.push(item);
    write(next);
    return next.some(function (i) { return String(i.id) === id; });
  }
  function heartSvg() {
    return '<svg class="rst-wish-outline" viewBox="0 0 24 24" fill="none" aria-hidden="true" width="20" height="20"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" stroke="currentColor" stroke-width="1.75" stroke-linejoin="round"/></svg><svg class="rst-wish-filled" viewBox="0 0 24 24" aria-hidden="true" width="20" height="20"><path fill="currentColor" d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';
  }
  function syncButton(btn) {
    if (!btn) return;
    var on = has(btn.getAttribute('data-product-id'));
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? 'Remove from saved' : 'Save for later');
    btn.title = on ? 'Saved' : 'Save';
  }
  function syncAllFor(id) {
    document.querySelectorAll('.rst-wish-btn[data-product-id="' + id + '"]').forEach(syncButton);
  }
  function syncCounts() {
    var n = read().length;
    document.querySelectorAll('[data-rst-wish-count]').forEach(function (el) {
      el.setAttribute('data-count', String(n));
      el.textContent = n > 0 ? String(n) : '';
    });
  }
  function itemFromBtn(btn) {
    return {
      id: btn.getAttribute('data-product-id'),
      handle: btn.getAttribute('data-product-handle') || '',
      title: btn.getAttribute('data-product-title') || '',
      url: btn.getAttribute('data-product-url') || '',
      image: btn.getAttribute('data-product-image') || '',
      price: btn.getAttribute('data-product-price') || ''
    };
  }
  function onHeartClick(e) {
    var btn = e.target.closest && e.target.closest('.rst-wish-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    var item = itemFromBtn(btn);
    if (!item.id) return;
    toggle(item);
    syncAllFor(item.id);
    syncCounts();
  }
  // Capture phase so we beat product-card overlay links
  document.addEventListener('click', onHeartClick, true);

  function bindButton(btn) {
    if (!btn || btn.dataset.rstBound === '1') return;
    btn.dataset.rstBound = '1';
    if (!btn.querySelector('svg')) btn.innerHTML = heartSvg();
    syncButton(btn);
  }

  function enhanceCards() {
    document.querySelectorAll('product-card[data-product-id]').forEach(function (card) {
      var id = card.getAttribute('data-product-id');
      if (!id || id === 'null') return;
      var host = card.querySelector('.card-gallery') || card;
      var existing = host.querySelector(':scope > .rst-wish-btn, .rst-wish-btn');
      if (existing) { bindButton(existing); return; }
      var link = card.querySelector('a.product-card__link, a[href*="/products/"]');
      var titleEl = card.querySelector('h3, .h4');
      var img = card.querySelector('img');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rst-wish-btn';
      btn.setAttribute('data-product-id', id);
      if (link) {
        var href = link.getAttribute('href') || '';
        btn.setAttribute('data-product-url', href);
        var m = href.match(/\/products\/([^/?#]+)/);
        if (m) btn.setAttribute('data-product-handle', decodeURIComponent(m[1]));
      }
      btn.setAttribute('data-product-title', ((titleEl && titleEl.textContent) || '').trim());
      if (img) btn.setAttribute('data-product-image', img.currentSrc || img.src || '');
      host.appendChild(btn);
      bindButton(btn);
    });
  }

  function renderWishlistPage() {
    var mount = document.querySelector('[data-rst-wishlist-page]');
    if (!mount) return;
    var list = read();
    var empty = mount.querySelector('[data-rst-wishlist-empty]');
    var grid = mount.querySelector('[data-rst-wishlist-grid]');
    if (!grid) return;
    grid.innerHTML = '';
    if (!list.length) { if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;
    list.forEach(function (item) {
      var a = document.createElement('a');
      a.className = 'rst-wishlist-card';
      a.href = item.url || ('/products/' + item.handle);
      a.innerHTML =
        (item.image ? '<img src="' + item.image + '" alt="">' : '<div style="aspect-ratio:4/5;background:#F5F2F4"></div>') +
        '<div class="rst-wishlist-card__title"></div>' +
        (item.price ? '<div class="rst-wishlist-card__price"></div>' : '') +
        '<button type="button" class="rst-wish-btn" data-product-id="' + item.id + '"></button>';
      a.querySelector('.rst-wishlist-card__title').textContent = item.title || 'Saved item';
      var priceEl = a.querySelector('.rst-wishlist-card__price');
      if (priceEl) priceEl.textContent = item.price;
      var btn = a.querySelector('.rst-wish-btn');
      ['handle','title','url','image','price'].forEach(function (k) {
        if (item[k]) btn.setAttribute('data-product-' + k, item[k]);
      });
      grid.appendChild(a);
      bindButton(btn);
    });
  }

  function refresh() {
    document.querySelectorAll('.rst-wish-btn').forEach(bindButton);
    document.querySelectorAll('.rst-wish-btn').forEach(syncButton);
    syncCounts();
    enhanceCards();
    renderWishlistPage();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
  window.addEventListener('rst:wishlist-changed', function () {
    document.querySelectorAll('.rst-wish-btn').forEach(syncButton);
    syncCounts();
    renderWishlistPage();
  });

  var t = null;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(enhanceCards, 200);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
